
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"56","height":"44","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":".664","y":".5","width":"54","height":"43","rx":"4.5","fill":"#27A6BD","stroke":"#CED4DA"}}),_c('path',{attrs:{"fill":"#fff","d":"M39.164 19.273v5.455h-22v-5.455zM28.164 12v5.455h-11V12zM33.055 26.547v5.455h-15.89v-5.455z"}})])
          )
        }
      }
    